<template>

<a href="#" class="product-image-link">
	<img class="thumbnail-image" :alt="product.title" :src="product.image_url">
</a>

</template>

<script>
export default {
	name: 'product-image-link',
	props: [ 'product' ]
}
</script>
